import React, { Component } from 'react'
import LazyLoad from 'react-lazy-load'
import './shared-book.scss'

class SharedBook extends Component {
    render() {
        const { sharedBook } = this.props;
        return (
            <div id="shared-book" className="sg_sharedBook">
                <LazyLoad offsetVertical={100} debounce={false}>
                    <img alt="" src={sharedBook.coverImage} width="14" className="sg_sharedBook__cover" />
                </LazyLoad>
                <h1>{sharedBook.title}</h1>
                <div className="sg_sharedBook__size">{sharedBook.downloadSize} MB [ {sharedBook.downloadType} ]</div>
                <a href={sharedBook.downloadURL} className="sg_sharedBook__download">Download Now</a>
                <p>{sharedBook.title} is available to buy <a href={sharedBook.purchaseURL}>here</a>.</p>
                <p>For additional information, <a href={"mailto:" + sharedBook.contactEmail + "?subject=" + encodeURIComponent(sharedBook.contactSubject)}>contact us</a>.</p>
            </div>
        )
    }
}

export default SharedBook